import { render } from "./ExportResultFiles.vue?vue&type=template&id=0bf8c0a6"
import script from "./ExportResultFiles.vue?vue&type=script&lang=js"
export * from "./ExportResultFiles.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/results/ExportResultFiles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bf8c0a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bf8c0a6', __exports__)) {
    console.log('reload')
    api.reload('0bf8c0a6', __exports__)
  }
  
  module.hot.accept("./ExportResultFiles.vue?vue&type=template&id=0bf8c0a6", () => {
    console.log('re-render')
    api.rerender('0bf8c0a6', render)
  })

}


export default __exports__